import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import { useContainerMediaQuery } from '@infl-ts/util-block-width-context';
import DoneIcon from '@mui/icons-material/Done';
import LockIcon from '@mui/icons-material/Lock';
import { Box, styled, Typography } from '@mui/material';
import { Translation } from 'react-i18next';
import { Badge } from '../badge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var LightTypography = styled(Typography)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (props) {
  return props.theme.palette.text.secondary;
});

var UnlockedLevel = function UnlockedLevel(_ref) {
  var name = _ref.name;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "UnlockedLevel",
    "data-source-file": "badge-list.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h3",
          sx: {
            color: function color(theme) {
              return theme.palette.text.primary;
            }
          },
          children: name || t('Other Badges')
        }), /*#__PURE__*/_jsxs(Typography, {
          variant: "h4",
          sx: {
            display: 'flex',
            color: function color(theme) {
              return theme.palette.success.main;
            }
          },
          children: [/*#__PURE__*/_jsx(DoneIcon, {}), t('Achieved')]
        })]
      });
    }
  });
};

var RemainingBadges = function RemainingBadges(_ref2) {
  var remainingBadges = _ref2.remainingBadges;
  return /*#__PURE__*/_jsx(LightTypography, {
    variant: "body1",
    "data-element": "LightTypography",
    "data-component": "RemainingBadges",
    "data-source-file": "badge-list.tsx",
    children: /*#__PURE__*/_jsx(Translation, {
      "data-element": "Translation",
      "data-component": "RemainingBadges",
      "data-source-file": "badge-list.tsx",
      children: function children(t) {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Box, {
            fontWeight: "fontWeightBold",
            component: "span",
            children: t("remainingBadgesText", {
              count: remainingBadges
            })
          }), t("required to unlock this level")]
        });
      }
    })
  });
};

var LockedLevel = function LockedLevel(_ref3) {
  var name = _ref3.name,
      remainingBadges = _ref3.remainingBadges;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(LightTypography, {
      variant: "h3",
      sx: {
        display: 'flex',
        alignItems: 'center'
      },
      noWrap: true,
      "data-element": "LightTypography",
      "data-component": "LockedLevel",
      "data-source-file": "badge-list.tsx",
      children: [name, /*#__PURE__*/_jsx(LockIcon, {
        sx: {
          height: 16
        },
        "data-element": "LockIcon",
        "data-component": "LockedLevel",
        "data-source-file": "badge-list.tsx"
      })]
    }), /*#__PURE__*/_jsx(RemainingBadges, {
      remainingBadges: remainingBadges,
      "data-element": "RemainingBadges",
      "data-source-file": "badge-list.tsx"
    })]
  });
};

var BadgeList = function BadgeList(_ref4) {
  var badgeProgressions = _ref4.badgeProgressions;
  var isMobile = useContainerMediaQuery({
    maxWidth: 'sm'
  });
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      display: 'flex',
      flexFlow: 'wrap',
      mb: 3
    },
    "data-element": "Box",
    "data-component": "BadgeList",
    "data-source-file": "badge-list.tsx",
    children: badgeProgressions.map(function (badgeProgression) {
      return /*#__PURE__*/_jsx(Box, {
        sx: {
          mr: 2
        },
        children: /*#__PURE__*/_jsx(Badge, {
          size: isMobile ? 'small' : 'large',
          badgeProgression: badgeProgression
        })
      }, badgeProgression.badge.id);
    })
  });
};

var BadgeListTitle = styled(Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  flex-flow: wrap;\n  margin-bottom: ", ";\n"])), function (p) {
  return p.theme.spacing(1);
});
export var OtherBadgeList = function OtherBadgeList(_ref5) {
  var badgeProgressions = _ref5.badgeProgressions;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "OtherBadgeList",
    "data-source-file": "badge-list.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(BadgeListTitle, {
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "h3",
            children: t('Other Badges')
          }), /*#__PURE__*/_jsx(LightTypography, {
            variant: "body1",
            children: t('These badges are not part of any particular level')
          })]
        }), /*#__PURE__*/_jsx(BadgeList, {
          badgeProgressions: badgeProgressions
        })]
      });
    }
  });
};
export var LevelBadgeList = function LevelBadgeList(_ref6) {
  var _levelProgress$earned;

  var levelProgress = _ref6.levelProgress,
      badgeProgressions = _ref6.badgeProgressions;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(BadgeListTitle, {
      "data-element": "BadgeListTitle",
      "data-component": "LevelBadgeList",
      "data-source-file": "badge-list.tsx",
      children: levelProgress.earned ? /*#__PURE__*/_jsx(UnlockedLevel, {
        name: levelProgress.level.name
      }) : /*#__PURE__*/_jsx(LockedLevel, {
        name: levelProgress.level.name,
        remainingBadges: levelProgress.requiredBadgesCount ? levelProgress.requiredBadgesCount - ((_levelProgress$earned = levelProgress.earnedBadgesCount) !== null && _levelProgress$earned !== void 0 ? _levelProgress$earned : 0) : 0
      })
    }), /*#__PURE__*/_jsx(BadgeList, {
      badgeProgressions: badgeProgressions,
      "data-element": "BadgeList",
      "data-source-file": "badge-list.tsx"
    })]
  });
};